// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
  aws_app_analytics: 'enable',
  aws_cloud_logic: 'enable',
  aws_cloud_logic_custom: [{
    id: 'n2h7o1jxm9', name: 'NamedAccont', description: '', endpoint: 'https://n2h7o1jxm9.execute-api.us-west-2.amazonaws.com/dev', region: 'us-west-2', paths: ['/echo', '/api/m/images', '/api/m/schedules', '/api/m/billOfLoads/create', '/api/m/billOfLoads/get', '/api/m/billOfLoads/getByLoadId', '/api/m/loads/complete', '/api/m/loads/get', '/api/m/loads/incomplete', '/api/m/loads/new'],
  }],
  // aws_cloud_logic_custom: [{
  //   id: '8iix0b5pv1', name: 'NamedAccont', description: '', endpoint: 'https://8iix0b5pv1.execute-api.us-east-1.amazonaws.com/dev', region: 'us-east-1', paths: ['/echo', '/api/m/images', '/api/m/schedules', '/api/m/billOfLoads/create', '/api/m/billOfLoads/get', '/api/m/billOfLoads/getByLoadId', '/api/m/loads/complete', '/api/m/loads/get', '/api/m/loads/incomplete', '/api/m/loads/new'],
  // }],
  aws_cognito_identity_pool_id: 'us-west-2:df7de935-011f-4c39-a30e-628a13aa7028',
  aws_cognito_region: 'us-west-2',
  aws_content_delivery: 'enable',
  aws_content_delivery_bucket: 'walmart-hosting-mobilehub-1443011653',
  aws_content_delivery_bucket_region: 'us-west-2',
  aws_content_delivery_cloudfront: 'enable',
  aws_content_delivery_cloudfront_domain: 'd2l4qnz8dqz8id.cloudfront.net',
  aws_mandatory_sign_in: 'enable',
  aws_mobile_analytics_app_id: 'd174978409df47b191a3d4ad027ead93',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_project_id: '940e70ce-72da-4590-af67-7ca3e797c533',
  aws_project_name: 'WALMART',
  aws_project_region: 'us-west-2',
  aws_resource_name_prefix: 'walmart-mobilehub-1443011653',
  aws_sign_in_enabled: 'enable',
  aws_user_pools: 'enable',
  aws_user_pools_id: 'us-west-2_1sWfHBYhC',
  aws_user_pools_mfa_type: 'OFF',
  aws_user_pools_web_client_id: '55oqh2flrfb6ld40sm0s5eil1k',
  itemApi: { 'endpoint': 'https://n2h7o1jxm9.execute-api.us-west-2.amazonaws.com/dev', 'region': 'us-west-2'},
  api:{
        'REST':{
            'endpoints':[
                  {
                        'name':'NamedAccont',
                        'endpoint':'https://n2h7o1jxm9.execute-api.us-west-2.amazonaws.com/dev'
                  }
            ]
        }    
  }
};

export default awsmobile;
